import React from 'react'
import useItemsBusquedas from '../../Hooks/useItemsBusquedas';
import Item from './Item';

const ItemsBusquedas = ({string}) => 
{
    const Items=useItemsBusquedas(string);
    
    return (
        <div>
            {Items.map(item => <Item item={item}/>)}
        </div>
    )
}

export default ItemsBusquedas
